(function () {
  'use strict';

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function shopifyImageSrc(src, width) {
    if (!src) return '';
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + width + 'x$1$3');
  }

  function formatPrice(priceStr) {
    var n = parseFloat(priceStr);
    if (isNaN(n)) return priceStr;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function normalizeFilterText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function handleizeFilterText(value) {
    return normalizeFilterText(value).replace(/\s+/g, '-');
  }

  function tagMatchesValue(tag, value) {
    if (!tag || !value) return false;
    if (tag === value) return true;

    var tagHandle = handleizeFilterText(tag);
    var valueHandle = handleizeFilterText(value);
    if (tagHandle === valueHandle) return true;

    var tagNorm = normalizeFilterText(tag);
    var valueNorm = normalizeFilterText(value);
    return tagNorm.indexOf(valueNorm + ' ') === 0 || valueNorm.indexOf(tagNorm + ' ') === 0;
  }

  function productTags(product) {
    var tags = product && product.tags;
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags.split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
    }
    return [];
  }

  function priceHtml(product, variant) {
    var price = formatPrice(variant.price);
    var tags = productTags(product);
    var type = product.product_type || '';
    if (type.indexOf('Featured Custom Build') !== -1 || tags.indexOf('sl-configurator') !== -1) {
      return price + ' set of 4';
    }
    if (tags.indexOf('Real Carbon Fiber Series') !== -1) {
      return (
        price + ' set of 4' +
        '<p style="margin-top:5px;font-size:12px;">20&quot; | 21&quot; | 22&quot; | 23&quot; (Various Widths)</p>' +
        '<p style="font-size:12px;">Center Lock &amp; Multi-Lug</p>'
      );
    }
    return 'starting at ' + price + ' ea.';
  }

  function variantCountHtml(product) {
    var count = (product.variants || []).length - 1;
    var gradient = 'background-image:linear-gradient(90deg,#e54214,#e5b01c,#34952a,#0d4fb2);-webkit-background-clip:text;color:transparent;';
    if (count >= 1) {
      return count + ' HOT OPTION + <span style="' + gradient + '">N CUSTOM FINISHES</span>';
    }
    return '<span style="' + gradient + '">N CUSTOM FINISHES</span>';
  }

  function productUrl(product) {
    if (product.url) return product.url;
    if (product.handle) return '/products/' + product.handle;
    return '#';
  }

  function productVariantUrl(product, variant) {
    var url = productUrl(product);
    if (!variant || !variant.id || url === '#') return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variant.id);
  }

  function buildCard(product, variant, withVariantLink, imageRatio) {
    variant = variant || (product.variants && product.variants[0]) || {};
    var productImages = product.images || [];
    var img = (variant.featured_image && variant.featured_image.src) ||
              (productImages[0] && productImages[0].src) || '';
    var imgSrc = shopifyImageSrc(img, 533);
    var url = withVariantLink ? productVariantUrl(product, variant) : productUrl(product);
    var variantLabel = (withVariantLink && variant.title && variant.title !== 'Default Title') ? variant.title : '';
    var ratio = imageRatio || '1/1';
    var ratioStyle = (ratio === 'original') ? '' : ('--aspect-ratio:' + ratio + ';');

    return (
      '<div class="sf__col-item w-6/12 md:w-4/12 px-2 xl:px-3">' +
        '<div class="sf__pcard cursor-pointer sf-prod__block" data-view="card">' +
          '<div class="sf__pcard-image">' +
            '<div class="overflow-hidden cursor-pointer relative sf__image-box">' +
              '<div class="flex justify-center items-center">' +
                '<a href="' + url + '" class="block w-full">' +
                  (imgSrc
                    ? '<div class="spc__main-img spc__img-only">' +
                        '<responsive-image class="sf-image" style="' + ratioStyle + '">' +
                          '<img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" class="se-out w-full h-full">' +
                        '</responsive-image>' +
                      '</div>'
                    : '') +
                '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="sf__pcard-content text-left relative">' +
            '<div class="mt-3 lg:mt-5">' +
              '<h3 class="block text-base">' +
                '<a href="' + url + '" class="block mb-[5px] leading-normal sf__pcard-name font-medium truncate-lines hover:text-color-secondary">' +
                  product.title +
                '</a>' +
              '</h3>' +
              (variantLabel ? '<p class="text-sm text-color-subtext mt-0.5">' + variantLabel + '</p>' : '') +
              '<div class="sf__pcard-price leading-normal">' + priceHtml(product, variant) + '</div>' +
              '<div><h3 class="block text-base">' + variantCountHtml(product) + '</h3></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  // ─── Dropdown ────────────────────────────────────────────────────────────────

  function Dropdown(el, filterDef) {
    this.el = el;
    this.type = filterDef.type || 'tag';
    this.placeholder = filterDef.placeholder || 'All';
    this.triggerText = el.querySelector('.cf-dropdown__trigger-text');
    this.panel = el.querySelector('.cf-dropdown__panel');
    this.searchInput = el.querySelector('.cf-dropdown__search');
    this.optionEls = Array.from(el.querySelectorAll('.cf-dropdown__option'));
    this.value = '';
    this._bind();
  }

  Dropdown.prototype._bind = function () {
    var self = this;

    this.el.querySelector('.cf-dropdown__trigger').addEventListener('click', function (e) {
      e.stopPropagation();
      self._toggle();
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', function () {
        self._filterOptions(this.value);
      });
      // Prevent panel close when clicking inside search
      this.searchInput.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    this.optionEls.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        self.select(opt);
      });
    });
  };

  Dropdown.prototype._toggle = function () {
    var isOpen = this.el.classList.contains('cf-dropdown--open');
    // Close all open dropdowns
    document.querySelectorAll('.cf-dropdown--open').forEach(function (d) {
      d.classList.remove('cf-dropdown--open');
      var t = d.querySelector('.cf-dropdown__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      this.el.classList.add('cf-dropdown--open');
      this.el.querySelector('.cf-dropdown__trigger').setAttribute('aria-expanded', 'true');
      if (this.searchInput) {
        this.searchInput.value = '';
        this._filterOptions('');
        this.searchInput.focus();
      }
    }
  };

  Dropdown.prototype._filterOptions = function (query) {
    var q = query.toLowerCase();
    this.optionEls.forEach(function (opt) {
      var matches = opt.textContent.toLowerCase().indexOf(q) !== -1;
      opt.classList.toggle('cf-dropdown__option--hidden', !matches);
    });
  };

  Dropdown.prototype.select = function (opt) {
    this.optionEls.forEach(function (o) { o.classList.remove('cf-dropdown__option--selected'); });
    opt.classList.add('cf-dropdown__option--selected');
    // data-cf-default marks the "All X" reset option
    var isDefault = opt.hasAttribute('data-cf-default');
    this.value = isDefault ? '' : opt.dataset.value || '';
    this.triggerText.textContent = isDefault ? this.placeholder : opt.textContent.trim();
    this.el.classList.remove('cf-dropdown--open');
    this.el.querySelector('.cf-dropdown__trigger').setAttribute('aria-expanded', 'false');
  };

  Dropdown.prototype.getValue = function () { return this.value; };

  Dropdown.prototype.reset = function () {
    this.optionEls.forEach(function (o) { o.classList.remove('cf-dropdown__option--selected', 'cf-dropdown__option--hidden'); });
    this.value = '';
    this.triggerText.textContent = this.placeholder;
    if (this.searchInput) this.searchInput.value = '';
    this.el.classList.remove('cf-dropdown--open');
  };

  // ─── Core ────────────────────────────────────────────────────────────────────

  var CollectionFilters = {
    section: null,
    sectionId: null,
    imageRatio: '1/1',
    dropdowns: [],
    cachedProducts: null,

    init: function () {
      this.section = document.querySelector('[data-section-type="collection-template"]');
      if (!this.section || !this.section.dataset.filterConfig) return;

      var config;
      try { config = JSON.parse(this.section.dataset.filterConfig); } catch (e) { return; }
      if (!config || !config.filters) return;

      this.sectionId = this.section.dataset.sectionId;
      this.imageRatio = this.section.dataset.imageRatio || '1/1';

      var self = this;
      var filterDefs = config.filters;

      document.querySelectorAll('.cf-dropdown').forEach(function (el) {
        var idx = parseInt(el.dataset.cfIndex, 10);
        var def = filterDefs[idx] || {};
        self.dropdowns.push(new Dropdown(el, def));
      });

      var findBtn = document.querySelector('[data-cf-find]');
      if (findBtn) findBtn.addEventListener('click', function () { self.applyFilters(); });

      var clearBtn = document.querySelector('[data-cf-clear]');
      if (clearBtn) clearBtn.addEventListener('click', function () { self.clearAll(); });

      // Close dropdowns on outside click
      document.addEventListener('click', function () {
        document.querySelectorAll('.cf-dropdown--open').forEach(function (d) {
          d.classList.remove('cf-dropdown--open');
          var t = d.querySelector('.cf-dropdown__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      });

      this.restoreFromUrl();
    },

    // ── Filter routing ────────────────────────────────────────────────────────

    applyFilters: function () {
      var tags = [];
      var keywords = [];

      this.dropdowns.forEach(function (dd) {
        var val = dd.getValue();
        if (!val) return;
        if (dd.type === 'tag') tags.push(val);
        else keywords.push(val.toLowerCase());
      });

      this.updateUrl(tags, keywords);

      if (tags.length === 0 && keywords.length === 0) {
        this.fetchAndUpdateGrid(this.buildCleanUrl());
        return;
      }

      this.applyClientSide(tags, keywords);
    },

    clearAll: function () {
      this.dropdowns.forEach(function (dd) { dd.reset(); });
      this.cachedProducts = null;
      window.history.pushState({}, '', this.buildCleanUrl());
      this.fetchAndUpdateGrid(this.buildCleanUrl());
    },

    // ── Server-side AJAX ──────────────────────────────────────────────────────

    fetchAndUpdateGrid: function (pageUrl) {
      var self = this;
      this.setLoading(true);

      var fetchUrl = new URL(pageUrl);
      fetchUrl.searchParams.set('section_id', this.sectionId);

      fetch(fetchUrl.toString())
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;

          var newContainer = tmp.querySelector('[data-product-container]');
          var oldContainer = document.querySelector('[data-product-container]');
          if (newContainer && oldContainer) {
            oldContainer.innerHTML = newContainer.innerHTML;
            oldContainer.dataset.totalPages = newContainer.dataset.totalPages || '1';
          }

          var oldPagination = document.querySelector('[data-pagination-wrapper]');
          var newPagination = tmp.querySelector('[data-pagination-wrapper]');
          if (oldPagination) oldPagination.remove();
          if (newPagination && oldContainer) oldContainer.after(newPagination);

          var grid = document.querySelector('#CollectionProductGrid');
          if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function (err) { console.error('[CF] fetch failed:', err); })
        .finally(function () { self.setLoading(false); });
    },

    // ── Client-side ───────────────────────────────────────────────────────────

    applyClientSide: function (tags, keywords) {
      var self = this;
      if (this.cachedProducts) {
        this.renderFiltered(this.cachedProducts, tags, keywords);
        return;
      }
      var productsUrl = this.getCollectionProductsUrl();
      if (!productsUrl) {
        if (tags.length === 1 && keywords.length === 0) {
          var url = new URL(this.buildCleanUrl());
          url.searchParams.set('filter.p.tag', tags[0]);
          this.fetchAndUpdateGrid(url.toString());
        }
        return;
      }
      this.setLoading(true);
      this.fetchAllProducts(productsUrl, function (products) {
        self.cachedProducts = products;
        self.renderFiltered(products, tags, keywords);
      });
    },

    fetchAllProducts: function (productsUrl, callback) {
      var allProducts = [];
      var page = 1;

      function nextPage() {
        var url = new URL(productsUrl, window.location.origin);
        url.searchParams.set('limit', '250');
        url.searchParams.set('page', page);
        fetch(url.toString())
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = data.products || [];
            allProducts = allProducts.concat(products);
            if (products.length === 250) { page++; nextPage(); }
            else { callback(allProducts); }
          })
          .catch(function (err) { console.error('[CF] products fetch failed:', err); });
      }

      nextPage();
    },

    renderFiltered: function (products, tags, keywords) {
      var matches = [];

      products.forEach(function (product) {
        // AND gate for tags: product must have ALL active tag values
        if (tags.length > 0) {
          var hasAllTags = tags.every(function (tag) {
            return productTags(product).some(function (productTag) {
              return tagMatchesValue(productTag, tag);
            });
          });
          if (!hasAllTags) return;
        }

        if (keywords.length > 0) {
          // Try product title first (must contain ALL keywords)
          var titleLower = normalizeFilterText(product.title);
          var titleMatch = keywords.every(function (kw) {
            return titleLower.indexOf(normalizeFilterText(kw)) !== -1;
          });
          if (titleMatch) {
            matches.push({ product: product, variant: product.variants[0], byVariant: false });
            return;
          }
          // Try each variant title (must contain ALL keywords)
          (product.variants || []).forEach(function (variant) {
            var vLower = normalizeFilterText(variant.title);
            var variantMatch = keywords.every(function (kw) {
              return vLower.indexOf(normalizeFilterText(kw)) !== -1;
            });
            if (variantMatch) {
              matches.push({ product: product, variant: variant, byVariant: true });
            }
          });
        } else {
          // Tags only (multiple) — client-side path, show first variant
          matches.push({ product: product, variant: product.variants[0], byVariant: false });
        }
      });

      var container = document.querySelector('[data-product-container]');
      if (!container) { this.setLoading(false); return; }
      var gfProducts = container.querySelector('#gf-products');
      if (!gfProducts) { this.setLoading(false); return; }

      var oldPagination = document.querySelector('[data-pagination-wrapper]');
      if (oldPagination) oldPagination.remove();

      if (matches.length === 0) {
        gfProducts.innerHTML =
          '<div class="empty-collection py-24 flex flex-col w-full items-center" style="width:100%">' +
            '<p class="mt-5 text-color-subtext">No products found for this combination.</p>' +
          '</div>';
        this.setLoading(false);
        return;
      }

      var ratio = this.imageRatio;
      gfProducts.innerHTML = matches.map(function (m) {
        return buildCard(m.product, m.variant, m.byVariant, ratio);
      }).join('');

      var grid = document.querySelector('#CollectionProductGrid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });

      this.setLoading(false);
    },

    // ── URL management ────────────────────────────────────────────────────────

    updateUrl: function (tags, keywords) {
      var url = new URL(this.buildCleanUrl());
      this.dropdowns.forEach(function (dd, idx) {
        var val = dd.getValue();
        if (val) url.searchParams.set('cf_' + idx, val);
      });
      window.history.pushState({}, '', url.toString());
    },

    buildCleanUrl: function () {
      var collectionUrl = this.section && this.section.dataset.collectionUrl;
      var url = collectionUrl
        ? new URL(collectionUrl, window.location.origin)
        : new URL(window.location.pathname, window.location.origin);
      var currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach(function (value, key) {
        url.searchParams.set(key, value);
      });
      var toDelete = [];
      url.searchParams.forEach(function (v, k) {
        if (/^cf_\d+$/.test(k) || k === 'filter.p.tag' || k === 'page' || k === 'section_id') toDelete.push(k);
      });
      toDelete.forEach(function (k) { url.searchParams.delete(k); });
      return url.toString();
    },

    // ── Restore from URL on load ──────────────────────────────────────────────

    restoreFromUrl: function () {
      var params = new URLSearchParams(window.location.search);
      var hasAny = false;
      var self = this;

      this.dropdowns.forEach(function (dd, idx) {
        var raw = params.get('cf_' + idx);
        if (!raw) return;
        var val = raw;
        // Find matching option element and select it
        var matchOpt = null;
        dd.el.querySelectorAll('.cf-dropdown__option').forEach(function (opt) {
          if (opt.dataset.value === val) matchOpt = opt;
        });
        if (!matchOpt && raw.indexOf('%') !== -1) {
          try {
            val = decodeURIComponent(raw);
            dd.el.querySelectorAll('.cf-dropdown__option').forEach(function (opt) {
              if (opt.dataset.value === val) matchOpt = opt;
            });
          } catch (e) {}
        }
        if (matchOpt) { dd.select(matchOpt); hasAny = true; }
      });

      if (hasAny) this.applyFilters();
    },

    // ── Utilities ─────────────────────────────────────────────────────────────

    getCollectionProductsUrl: function () {
      var collectionUrl = this.section && this.section.dataset.collectionUrl;
      if (!collectionUrl) return null;
      var pathname = new URL(collectionUrl, window.location.origin).pathname.replace(/\/$/, '');
      return pathname + '/products.json';
    },

    setLoading: function (on) {
      var container = document.querySelector('[data-product-container]');
      if (!container) return;
      container.style.opacity = on ? '0.4' : '';
      container.style.pointerEvents = on ? 'none' : '';
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    CollectionFilters.init();
  });
})();
